import { useState, useMemo } from "react";
import {
  List,
  ListItemButton,
  ListItemText,
  Box,
  Paper,
  Typography,
} from "@mui/material";
import "./card.scss";
import Label from "../Label/Label";

export default function SampleAccordionList({
  data,
  openData,
  handleMenuOptionCallBack,
  handleMenuClick,
  batchID,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [menuItemLabel, setMenuItemLabel] = useState(null);

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuItemLabel(null);
  };

  const handleChildMenuClose = () => {
    setAnchorE2(null);
    setMenuItemLabel(null);
  };

  const handleMenuOption = (option, item) => {
    handleMenuOptionCallBack(option, item);
    handleMenuClose();
    handleChildMenuClose();
  };

  // ✅ Group data by phase (skip invalid tabs)
  const groupedData = useMemo(() => {
    const groups = {};
    data?.data?.forEach((item) => {
      // ❌ skip if no tab OR no rows
      if (!item?.tab?.trim() ) return;
      // if (!item?.tab?.trim() || !item?.rows || item.rows.length === 0) return;

      const phase = item.phase || "";
      if (!groups[phase]) groups[phase] = [];
      groups[phase].push(item);
    });

    return groups;
  }, [data]);
  
  // ✅ Sort + remove empty phases
  const sortedPhases = useMemo(() => {
    return Object.keys(groupedData)
      .filter((phase) => groupedData[phase]?.length > 0)
      .sort((a, b) => {
        if (!a) return -1; // no phase first
        if (!b) return 1;
        return a.localeCompare(b);
      });
  }, [groupedData]);

  return (
    <Paper elevation={1} className="sample-container" sx={{ height: "100%" }}>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid #ccc",
          mb: 1,
        }}
      >
        <Label
          padding="12px 14px 12px 12px"
          text={"Batch ID : " + batchID}
        />
      </Box>

      {/* ✅ Render only valid phases */}
      {sortedPhases.length > 0 ? (
        <List component="nav" disablePadding>
          {sortedPhases.map((phase, idx) => {
            const phaseLabel = phase || "";

            return (
              <Box key={idx} className="phase-section">
                {/* Phase Header */}
                {phase && (
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 600,
                      backgroundColor: "#e6ebf2",
                      px: 2,
                      border: "1px solid #ccc",
                      mb: 1,
                      mt: 1,
                    }}
                  >
                    Phase- {phaseLabel}
                  </Typography>
                )}

                {/* Items */}
                {groupedData[phase].map((item, index) => (
                  <ListItemButton
                    key={index}
                    className={`menu-list-item ${openData?.tab === item.tab &&
                        item.phase === openData.phase
                        ? "active"
                        : ""
                      }`}
                    onClick={() => handleMenuClick(item)}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <ListItemText
                      primary={item.tab}
                      className="list-item-text"
                      primaryTypographyProps={{
                        sx: {
                          color:
                            openData?.tab === item.tab &&
                              item.phase === openData.phase
                              ? "#fff"
                              : "black",
                          cursor: "pointer",
                          width: "100%",
                        },
                      }}
                    />
                  </ListItemButton>
                ))}
              </Box>
            );
          })}
        </List>
      ) : (
        <Typography
          sx={{
            p: 2,
            textAlign: "center",
            color: "#888",
          }}
        >
          No data available
        </Typography>
      )}
    </Paper>
  );
}